module.exports = __webpack_public_path__ + "img/pc-select-checked.6eb253cd.svg";